import { Button } from '../../../../../core/components/atoms/Button';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { ListFilterModal } from '../../../../../core/components/organism/ListFilterModal';
import { useLiveExamsListTab } from '../../../hooks/AprovaLive/useLiveExamsListTab';
import { PastEventsListLoading } from '../../PastEventsListLoading';
import { LiveSimulationList } from '../LiveSimulationList';
import StartSimulationModal from '../StartSimulationModal';

interface LiveExamsListTabProps {
  origin?: 'live' | 'challenge';
}

function LiveExamsListTab({ origin = 'live' }: LiveExamsListTabProps) {
  const {
    simulationsList,
    filteredSimulationsList,
    isStartSimulationModalOpen,
    handleSimulationAction,
    handleCloseStartModal,
    handleStartSimulation,
    selectedSimulation,
    getTimeToFinish,
    filters,
    isModalFilterOpen,
    setIsModalFilterOpen,
    selectedFilters,
    setSelectedFilters,
    isLoadingList,
  } = useLiveExamsListTab(origin);

  if (!simulationsList) {
    return <p>Carregando</p>;
  }

  return (
    <div className='flex flex-col gap-lg'>
      <header className='mt-8 flex flex-col gap-8'>
        <div className='flex flex-row items-center justify-between gap-8'>
          <Typography>
            {simulationsList.length === 1
              ? '1 simulado'
              : `${simulationsList.length} simulados`}
          </Typography>
          <Button
            variant='text'
            LeftIcon={'filter_list'}
            onClick={() => {
              setIsModalFilterOpen(true);
            }}
            className='md:mt-auto'
            disabled={simulationsList.length === 0}
          >
            Filtrar simulados
          </Button>
        </div>
      </header>

      {isLoadingList ? (
        <PastEventsListLoading itensCount={5} />
      ) : (
        <LiveSimulationList
          simulationsList={filteredSimulationsList}
          handleSimulationAction={handleSimulationAction}
        />
      )}

      <ListFilterModal
        title='Filtrar simulados'
        subtitle='Aprovalive'
        filters={filters}
        isOpen={isModalFilterOpen}
        onClose={() => {
          setIsModalFilterOpen(false);
        }}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />

      <StartSimulationModal
        isOpen={isStartSimulationModalOpen}
        onClose={handleCloseStartModal}
        handleStart={handleStartSimulation}
        isStartButtonLoading={false}
        questionsCount={selectedSimulation?.totalQuestions ?? 0}
        timeToFinish={getTimeToFinish()}
      />
    </div>
  );
}

export { LiveExamsListTab };
